import React from 'react';
import ProblemReportsContainer from './ProblemReportsContainer';


const ProblemReports = (props) => (
  <ProblemReportsContainer {...props} />
)

export default ProblemReports;


// WEBPACK FOOTER //
// src/routes/ProblemReports/index.js